<div class="relative h-full w-full rounded-xl overflow-hidden border border-[var(--app-border)]">

  <google-map #map
    height="100%"
    width="100%"
    [center]="mapCenter"
    [zoom]="mapZoom"
    [options]="mapOptions"
    (zoomChanged)="onZoomChanged()">

    <!-- Field boundaries -->
    <map-polygon *ngFor="let polygon of polygons; trackBy: trackByFieldId"
      [paths]="polygon.paths"
      [options]="fieldPolygonOptions">
    </map-polygon>

    <!-- Overlap rings: drawn in metres so the radius means something -->
    <map-circle *ngFor="let circle of overlapCircles; trackBy: trackByIndex"
      [center]="circle.centre"
      [radius]="circle.radius"
      [options]="overlapCircleOptions">
    </map-circle>

    <!-- Pins. Content elements are pre-built, never created in the template. -->
    <map-advanced-marker *ngFor="let marker of markers; trackBy: trackByPinId"
      [position]="marker.position"
      [content]="marker.content"
      (mapClick)="onMarkerClick(marker.pinId)">
    </map-advanced-marker>
  </google-map>

  <!-- Map controls -->
  <div class="absolute top-3 left-3 bg-white rounded-[10px] shadow-[0_4px_16px_rgba(0,0,0,0.22)] p-2.5 flex flex-col gap-1.5 text-[var(--base-text-dark)]">
    <label class="flex items-center justify-between gap-3 text-[12px] font-medium whitespace-nowrap">
      <span>Sample names</span>
      <select class="border border-[var(--app-border)] rounded-md text-[11px] px-1.5 py-1 outline-none text-[var(--base-text-dark)] bg-white"
        [value]="labelMode()"
        (change)="onLabelModeChange($any($event.target).value)">
        <option value="name">Name</option>
        <option value="both">Name + barcode</option>
        <option value="none">Off</option>
      </select>
    </label>
    <label class="flex items-center justify-between gap-3 text-[12px] font-medium whitespace-nowrap cursor-pointer">
      <span>Highlight overlaps</span>
      <input type="checkbox" class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer"
        [checked]="showOverlaps()" (change)="toggleOverlaps()">
    </label>
    <label class="flex items-center justify-between gap-3 text-[12px] font-medium whitespace-nowrap cursor-pointer">
      <span>Spread stacked pins</span>
      <input type="checkbox" class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer"
        [checked]="spreadStacked()" (change)="toggleSpread()">
    </label>
  </div>

  <!-- Zoom cluster, bottom-right, matching the maps module -->
  <div class="absolute bottom-3 right-3 flex flex-col rounded-lg overflow-hidden bg-white shadow-[0_4px_16px_rgba(0,0,0,0.22)]">
    <button type="button" (click)="zoomIn()" title="Zoom in"
      class="w-8 h-8 flex items-center justify-center border-b border-[var(--app-base)] text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] hover:text-[var(--primary-dark)]">
      <span class="material-icons text-[19px]">add</span>
    </button>
    <button type="button" (click)="zoomOut()" title="Zoom out"
      class="w-8 h-8 flex items-center justify-center border-b border-[var(--app-base)] text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] hover:text-[var(--primary-dark)]">
      <span class="material-icons text-[19px]">remove</span>
    </button>
    <button type="button" (click)="fit()" title="Fit to group"
      class="w-8 h-8 flex items-center justify-center text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] hover:text-[var(--primary-dark)]">
      <span class="material-icons text-[19px]">fit_screen</span>
    </button>
  </div>

  <!-- Empty and loading states -->
  <div *ngIf="loading()"
    class="absolute inset-0 flex items-center justify-center bg-white/70 text-[13px] text-[var(--tertiary-text)]">
    Loading pins...
  </div>
  <div *ngIf="!loading() && pins().length === 0"
    class="absolute inset-0 flex items-center justify-center bg-white text-[13px] text-[var(--tertiary-text)]">
    No pins in this sample group have a position.
  </div>
</div>
